import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import PlusThickIcon from 'mdi-react/PlusThickIcon';
import { withTranslation } from 'react-i18next';
import { check, findAllOrgao, findAllOrgaoByUserADM, findAllByOrgaoUser_orgao } from "../../Services/OrgaoService";
import { findAllUsersByOrgaosStatus } from "../../Services/UsersService";
import { findAllEstado } from "../../Services/EstadoService";
import { checkKey, hasAccess, hasGroupAccess } from "../../Services/SecurityService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { environment } from '../../environment';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      hasAccess: false,
      selected: {},
      user: {},
      users: [],
      estados: [],
      orgaoUsers: [],
      orgaos: [],
      data: []
    };
    check();
  }

  loadOrgao(selected){
    if(hasGroupAccess("ROOT") || hasGroupAccess("ADMINISTRADORES")){
      findAllOrgao()
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let orgaos = [];
          for(let i = 0; i < data.length; i++){
            if(data[i].orgao == null || data[i].orgao == undefined || 
              data[i].orgao.id == null || data[i].orgao.id == undefined){
              //pega os orgãos que não possuem orgão acima
              orgaos.push(data[i]);
            }
          }
  
          this.setState({ data: data, orgaos, selected });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }else if(hasGroupAccess("PREFEITURAS_ADMINISTRADORES")){
      findAllOrgaoByUserADM(environment.getUser())
      .then(data => {
        if(data === undefined){
          data = [];
        }
        if(data !== undefined && data.error === undefined){
          let orgaos = [];
          for(let i = 0; i < data.orgaoList.length; i++){
            if(data.orgaoList[i].orgao == null || data.orgaoList[i].orgao == undefined || 
              data.orgaoList[i].orgao.id == null || data.orgaoList[i].orgao.id == undefined){
              //pega os orgãos que não possuem orgão acima
              orgaos.push(data.orgaoList[i]);
            }
          }
  
          this.setState({ data: data.orgaoList, orgaos, selected });
        } else {
          if(data.errors === undefined){
            data = [];
            this.show('danger', this.props.t('forms.errorListData'));
          } else {
            data = [];
            this.show('danger', data.errors[0].defaultMessage);
          }
        }
      });
    }
  }

  loadUser(){
    let user = environment.getUser();
    findAllUsersByOrgaosStatus()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        for(let i = 0; i < data.length; i++){
          if(user.id == data[i].id){
            user = data[i];
            break;
          }
        }
        this.setState({ users: data, user, hasAccess: true });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadEstado(){
    findAllEstado()
    .then(response => {
      if(response === undefined){
        response = [];
      }
      if(response !== undefined && response.error === undefined){
        this.setState({ 
          estados: response
        }, () => {});
      } else {
        if(response.errors === undefined){
          response = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          response = [];
          this.show('danger', response.errors[0].defaultMessage);
        }
      }
    });
  }

  loadOrgaoUser(selected){
    findAllByOrgaoUser_orgao(selected)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ selected, orgaoUsers: data.orgaoUserList });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_ORGAO_VIEW")){
      this.loadOrgao({});
      this.loadUser();
      this.loadEstado();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.loadOrgaoUser(selected);
  }

  setSelectedNew = () => {
    this.setState({ selected: {id: 0} });
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadOrgao(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_ORGAO_NEW");

    let view = '';
    let disabled = false;

    if(this.state.hasAccess){
      if(this.state.selected.id !== null && this.state.selected.id !== undefined){
        disabled = (this.state.selected.id === 0);
        view =  <CrudEdit 
                  selected = {this.state.selected}
                  users = {this.state.users}
                  user = {this.state.user}
                  estados = {this.state.estados}
                  orgaos = {this.state.orgaos}
                  orgaoUsers = {this.state.orgaoUsers}
                  updateTable = {this.updateTable} />
      }else{
        view =  <MatTable 
                  title={t('forms.list')}
                  list={this.state.data}
                  setSelected = {this.setSelected}
                  updateTable = {this.updateTable} />
      }
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.orgao_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.orgao_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.setSelectedNew()}>
                <PlusThickIcon /> {t('forms.new')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);